import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonLink } from 'components/shared/ButtonLink';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { StyledContainer, StyledHow, StyledVideo } from './LaunchVideo.styled';

const LaunchVideo: React.FC = () => {
  const { t } = useI18n('launch-landing');
  const { locale } = useRouter();

  return (
    <StyledHow>
      <StyledContainer>
        <Heading2 editorial>{t('manifest.title')}</Heading2>
        <StyledVideo>
          <iframe
            src="https://www.youtube.com/embed/E1KTTjgfqg8"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </StyledVideo>
        <ButtonLink href={`${getAppUrl(APP_URLS.login, locale)}`}>
          <FontAwesomeIcon icon={faCheckCircle} />
          <span>{t('manifest.cta')}</span>
        </ButtonLink>
      </StyledContainer>
    </StyledHow>
  );
};

export default LaunchVideo;
